import { createIcon } from "@hopper-ui/icons";
import { type ComponentProps, useId } from "react";

const O365Groups32 = (props: ComponentProps<"svg">) => {
    const id = useId();

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="m14.4505 3.79691-.13483.07908c-.21443.12578-.41647.26638-.605.42011l.38886-.26523H17.4l.6 4.40553-3 2.9091-3 1.8364v2.3316c0 1.6285.8777 3.1385 2.3144 3.982l3.1582 1.8537-6.6726 3.7743h-1.28695l-2.3986-1.4079C5.8777 23.058 5 21.5479 5 19.9193v-7.8405c0-1.6291.87827-3.1396 2.31572-3.9827l7.19998-4.23149c.0447-.02616.0896-.05157.1348-.07621Z"
                fill={`url(#${id}-a32)`}
            />
            <path
                d="m14.4505 3.79691-.13483.07908c-.21443.12578-.41647.26638-.605.42011l.38886-.26523H17.4l.6 4.40553-3 2.9091-3 1.8364v2.3316c0 1.6285.8777 3.1385 2.3144 3.982l3.1582 1.8537-6.6726 3.7743h-1.28695l-2.3986-1.4079C5.8777 23.058 5 21.5479 5 19.9193v-7.8405c0-1.6291.87827-3.1396 2.31572-3.9827l7.19998-4.23149c.0447-.02616.0896-.05157.1348-.07621Z"
                fill={`url(#${id}-b32)`}
            />
            <path
                d="M21.6 13.0909v2.6067c0 1.6286-.8777 3.1386-2.3144 3.9818l-7.1944 4.2238c-1.47288.8646-3.30546.8959-4.80427.0936l7.03307 4.1284c1.528.897 3.4432.897 4.9712 0l7.2-4.2262c1.4368-.8433 2.4-2.3534 2.4-3.9821v-1.883l-.6-.8724-5.8-4.0725Z"
                fill={`url(#${id}-c32)`}
            />
            <path
                d="M21.6 13.0909v2.6067c0 1.6286-.8777 3.1386-2.3144 3.9818l-7.1944 4.2238c-1.47288.8646-3.30546.8959-4.80427.0936l7.03307 4.1284c1.528.897 3.4432.897 4.9712 0l7.2-4.2262c1.4368-.8433 2.4-2.3534 2.4-3.9821v-1.883l-.6-.8724-5.8-4.0725Z"
                fill={`url(#${id}-d32)`}
            />
            <path
                d="m26.4842 8.09621-7.2-4.22312c-1.48-.86811-3.3231-.89502-4.82557-.08069l-.14305.08359C12.8783 4.71911 12 6.22988 12 7.85893v5.51791l2.3157-1.3583c1.5273-.8958 3.4413-.8958 4.9686 0l7.2 4.2231c1.3925.8168 2.257 2.2599 2.3131 3.8303.0018-.0507.0026-.1014.0026-.1523V12.0789c0-1.6291-.8783-3.1396-2.3158-3.98269Z"
                fill={`url(#${id}-e32)`}
            />
            <path
                d="m26.4842 8.09621-7.2-4.22312c-1.48-.86811-3.3231-.89502-4.82557-.08069l-.14305.08359C12.8783 4.71911 12 6.22988 12 7.85893v5.51791l2.3157-1.3583c1.5273-.8958 3.4413-.8958 4.9686 0l7.2 4.2231c1.3925.8168 2.257 2.2599 2.3131 3.8303.0018-.0507.0026-.1014.0026-.1523V12.0789c0-1.6291-.8783-3.1396-2.3158-3.98269Z"
                fill={`url(#${id}-f32)`}
            />
            <defs>
                <radialGradient
                    id={`${id}-a32`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-12.8 22.4 -49.6 -30.4 19.4384 8.47159)"
                >
                    <stop offset=".06441" stopColor="#AE7FE2" />
                    <stop offset="1" stopColor="#0078D4" />
                </radialGradient>
                <radialGradient
                    id={`${id}-c32`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(20.8 -4.8 3.2 19.2 6.33537 19.6519)"
                >
                    <stop offset=".133928" stopColor="#D59DFF" />
                    <stop offset="1" stopColor="#5E438F" />
                </radialGradient>
                <radialGradient
                    id={`${id}-e32`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-20.8 -4.8 9.6 -35.2 26.2759 24.8321)"
                >
                    <stop offset=".0584996" stopColor="#50E6FF" />
                    <stop offset="1" stopColor="#436DCD" />
                </radialGradient>
                <linearGradient
                    id={`${id}-b32`}
                    x1="19.5404"
                    y1="27.3241"
                    x2="17.0805"
                    y2="20.6207"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#114A8B" />
                    <stop offset="1" stopColor="#0078D4" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-d32`}
                    x1="26.3619"
                    y1="9.24704"
                    x2="21.2082"
                    y2="14.463"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#493474" />
                    <stop offset="1" stopColor="#8C66BA" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-f32`}
                    x1="12.5855"
                    y1="3.81475"
                    x2="17.0922"
                    y2="3.81475"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D3F80" />
                    <stop offset="1" stopColor="#436DCD" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const O365Groups24 = (props: ComponentProps<"svg">) => {
    const id = useId();

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="m10.8379 2.84769-.10112.05931c-.16082.09434-.31235.19979-.45373.31509l.29165-.19893H13.05l.45 3.30415-2.25 2.18182-2.25 1.37727v1.74872c0 1.2214.65831 2.3539 1.73583 2.9865l2.36864 1.3903-5.00448 2.8308h-.96521l-1.79898-1.0559C4.65829 17.2936 4 16.161 4 14.9396V9.05907c0-1.22177.6587-2.35467 1.73678-2.98699l5.39997-3.1736c.0335-.01962.0672-.03868.1011-.05716Z"
                fill={`url(#${id}-a24)`}
            />
            <path
                d="m10.8379 2.84769-.10112.05931c-.16082.09434-.31235.19979-.45373.31509l.29165-.19893H13.05l.45 3.30415-2.25 2.18182-2.25 1.37727v1.74872c0 1.2214.65831 2.3539 1.73583 2.9865l2.36864 1.3903-5.00448 2.8308h-.96521l-1.79898-1.0559C4.65829 17.2936 4 16.161 4 14.9396V9.05907c0-1.22177.6587-2.35467 1.73678-2.98699l5.39997-3.1736c.0335-.01962.0672-.03868.1011-.05716Z"
                fill={`url(#${id}-b24)`}
            />
            <path
                d="M16.2 9.81821v1.95504c0 1.2214-.6583 2.3539-1.7358 2.9864l-5.3958 3.1679c-1.10466.6485-2.47909.6719-3.6032.0702l5.27482 3.0963c1.146.6726 2.5824.6726 3.7284 0l5.4-3.1697c1.0776-.6326 1.2-1.7652 1.2-2.9866v-1.4123l-.45-.6544-4.35-3.0546Z"
                fill={`url(#${id}-c24)`}
            />
            <path
                d="M16.2 9.81821v1.95504c0 1.2214-.6583 2.3539-1.7358 2.9864l-5.3958 3.1679c-1.10466.6485-2.47909.6719-3.6032.0702l5.27482 3.0963c1.146.6726 2.5824.6726 3.7284 0l5.4-3.1697c1.0776-.6326 1.2-1.7652 1.2-2.9866v-1.4123l-.45-.6544-4.35-3.0546Z"
                fill={`url(#${id}-d24)`}
            />
            <path
                d="m19.8632 6.07216-5.4-3.16735c-1.11-.65108-2.4923-.67126-3.61919-.06052l-.10728.06269C9.6587 3.53933 9 4.67241 9 5.89421v4.13843l1.7368-1.01873c1.1455-.67184 2.581-.67184 3.7265 0l5.4 3.16729c1.0444.6126 1.6953 1.6949 1.7349 2.8727.0013-.0381.0018-.0761.0018-.1143V9.05915c0-1.22177-.6587-1.35467-1.7368-2.98699Z"
                fill={`url(#${id}-e24)`}
            />
            <path
                d="m19.8632 6.07216-5.4-3.16735c-1.11-.65108-2.4923-.67126-3.61919-.06052l-.10728.06269C9.6587 3.53933 9 4.67241 9 5.89421v4.13843l1.7368-1.01873c1.1455-.67184 2.581-.67184 3.7265 0l5.4 3.16729c1.0444.6126 1.6953 1.6949 1.7349 2.8727.0013-.0381.0018-.0761.0018-.1143V9.05915c0-1.22177-.6587-1.35467-1.7368-2.98699Z"
                fill={`url(#${id}-f24)`}
            />
            <defs>
                <radialGradient
                    id={`${id}-a24`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-9.6 16.8 -37.2 -22.8 14.5788 6.35369)"
                >
                    <stop offset=".06441" stopColor="#AE7FE2" />
                    <stop offset="1" stopColor="#0078D4" />
                </radialGradient>
                <radialGradient
                    id={`${id}-c24`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(15.6 -3.6 2.4 14.4 4.75153 14.7389)"
                >
                    <stop offset=".133928" stopColor="#D59DFF" />
                    <stop offset="1" stopColor="#5E438F" />
                </radialGradient>
                <radialGradient
                    id={`${id}-e24`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-15.6 -3.6 7.2 -26.4 19.7069 18.624)"
                >
                    <stop offset=".0584996" stopColor="#50E6FF" />
                    <stop offset="1" stopColor="#436DCD" />
                </radialGradient>
                <linearGradient
                    id={`${id}-b24`}
                    x1="14.6553"
                    y1="20.4931"
                    x2="12.8104"
                    y2="15.4655"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#114A8B" />
                    <stop offset="1" stopColor="#0078D4" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-d24`}
                    x1="19.7714"
                    y1="6.93528"
                    x2="15.9061"
                    y2="10.8472"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#493474" />
                    <stop offset="1" stopColor="#8C66BA" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-f24`}
                    x1="9.4391"
                    y1="2.86106"
                    x2="12.8191"
                    y2="2.86106"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D3F80" />
                    <stop offset="1" stopColor="#436DCD" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const O365Groups16 = (props: ComponentProps<"svg">) => {
    const id = useId();

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="m7.22525 1.89846-.06741.03954c-.10722.06289-.20823.1332-.30249.21006l.19444-.13262H8.7l.3 2.20276-1.5 1.45455L6 6.68377v1.16582c0 .81425.43887 1.56929 1.15722 1.99097l1.57909.9269-3.33632 1.8872h-.64347l-1.19932-.7039C3.43886 11.529 3 10.774 3 9.95973V6.03947c0-.81451.43913-1.56978 1.15785-1.99133l3.59998-2.11573c.02232-.01308.04479-.02578.06742-.03811Z"
                fill={`url(#${id}-a16)`}
            />
            <path
                d="m7.22525 1.89846-.06741.03954c-.10722.06289-.20823.1332-.30249.21006l.19444-.13262H8.7l.3 2.20276-1.5 1.45455L6 6.68377v1.16582c0 .81425.43887 1.56929 1.15722 1.99097l1.57909.9269-3.33632 1.8872h-.64347l-1.19932-.7039C3.43886 11.529 3 10.774 3 9.95973V6.03947c0-.81451.43913-1.56978 1.15785-1.99133l3.59998-2.11573c.02232-.01308.04479-.02578.06742-.03811Z"
                fill={`url(#${id}-b16)`}
            />
            <path
                d="M10.8 6.54547v1.30336c0 .81428-.4389 1.56932-1.1572 1.99092l-3.5972 2.11195c-.73644.4323-1.65273.4479-2.40213.0468l3.51655 2.0642c.76398.4484 1.72161.4484 2.48561 0l3.6-2.1131C13.9611 11.529 14 10.774 14 9.95967v-.94152l-.3-.4363-2.9-2.03638Z"
                fill={`url(#${id}-c16)`}
            />
            <path
                d="M10.8 6.54547v1.30336c0 .81428-.4389 1.56932-1.1572 1.99092l-3.5972 2.11195c-.73644.4323-1.65273.4479-2.40213.0468l3.51655 2.0642c.76398.4484 1.72161.4484 2.48561 0l3.6-2.1131C13.9611 11.529 14 10.774 14 9.95967v-.94152l-.3-.4363-2.9-2.03638Z"
                fill={`url(#${id}-d16)`}
            />
            <path
                d="m13.2422 4.04811-3.6-2.11157c-.74-.43406-1.66152-.44751-2.41279-.04035l-.07152.0418C6.43913 2.35955 6 3.11494 6 3.92947v2.75896l1.15785-.67915c.76368-.4479 1.72063-.4479 2.48431 0l3.6 2.11152c.6962.4084 1.1302 1.1299 1.1566 1.9151.0008-.0254.0012-.0507.0012-.0762V6.03943c0-.81451-.4391-1.56976-1.1578-1.99132Z"
                fill={`url(#${id}-e16)`}
            />
            <path
                d="m13.2422 4.04811-3.6-2.11157c-.74-.43406-1.66152-.44751-2.41279-.04035l-.07152.0418C6.43913 2.35955 6 3.11494 6 3.92947v2.75896l1.15785-.67915c.76368-.4479 1.72063-.4479 2.48431 0l3.6 2.11152c.6962.4084 1.1302 1.1299 1.1566 1.9151.0008-.0254.0012-.0507.0012-.0762V6.03943c0-.81451-.4391-1.56976-1.1578-1.99132Z"
                fill={`url(#${id}-f16)`}
            />
            <defs>
                <radialGradient
                    id={`${id}-a16`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-6.4 11.2 -24.8 -15.2 9.71923 4.2358)"
                >
                    <stop offset=".06441" stopColor="#AE7FE2" />
                    <stop offset="1" stopColor="#0078D4" />
                </radialGradient>
                <radialGradient
                    id={`${id}-c16`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(10.4 -2.4 1.6 9.6 3.16769 9.82594)"
                >
                    <stop offset=".133928" stopColor="#D59DFF" />
                    <stop offset="1" stopColor="#5E438F" />
                </radialGradient>
                <radialGradient
                    id={`${id}-e16`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-10.4 -2.4 4.8 -17.6 13.1379 12.416)"
                >
                    <stop offset=".0584996" stopColor="#50E6FF" />
                    <stop offset="1" stopColor="#436DCD" />
                </radialGradient>
                <linearGradient
                    id={`${id}-b16`}
                    x1="9.77019"
                    y1="13.6621"
                    x2="8.54025"
                    y2="10.3103"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#114A8B" />
                    <stop offset="1" stopColor="#0078D4" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-d16`}
                    x1="13.181"
                    y1="4.62352"
                    x2="10.6041"
                    y2="7.23148"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#493474" />
                    <stop offset="1" stopColor="#8C66BA" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`${id}-f16`}
                    x1="6.29273"
                    y1="1.90738"
                    x2="8.54609"
                    y2="1.90738"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D3F80" />
                    <stop offset="1" stopColor="#436DCD" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const O365GroupsIcon = createIcon(O365Groups16, O365Groups24, O365Groups32, "O365GroupsIcon");
